import { inject, reactive } from "vue";
import Auth from "./Auth";

export default function Distribution() {
  const axios = inject("axios");
  const { loggedOut } = Auth(); 

  const company = reactive({
    data: [],
    loading: false,
  });

  const brands = reactive({
    data: [],
    loading: false,
  });

  const products = reactive({
    data: {},
    loading: {},
  });
  const categories = reactive({
    data: {},
    loading: {},
  });

  const company_details = () => {
    company.loading = true;
    axios.authApi.get("distributor/company").then((res) => {
      company.data = res.data.data;
    });
  };

  const getProducts = (brand_id, category_id, filters = {}, force = false) => {
    if (!products.data[brand_id]) {
      products.data[brand_id] = {};
    }

    if (force) {
      delete products.data[brand_id][category_id];
    }

    products.loading[`${brand_id}-${category_id}`] = true; // Set loading to true

    if (!products.data[brand_id][category_id]) {
      const params = { brand_id, category_id };
      if (filters.in_stock) params.in_stock = 1;
      if (filters.never_ordered) params.never_ordered = 1;

      return axios.authApi
        .get("distributor/products", { params })
        .then((res) => {
          const rows = res.data.data.data;
          products.data[brand_id][category_id] = rows.sort((a, b) =>
            String(a?.title || a?.name || "").localeCompare(String(b?.title || b?.name || ""), undefined, { sensitivity: "base" })
          ).map((p) => {
            const sorted = [...(p.variants || [])].sort((a, b) =>
              String(a?.opt1 || "").localeCompare(String(b?.opt1 || ""), undefined, { numeric: true, sensitivity: "base" })
            );
            const inStock = sorted.filter((v) => Number(v?.available_stock) > 0);
            const outOfStock = sorted.filter((v) => Number(v?.available_stock) <= 0);
            return { ...p, variants: [...inStock, ...outOfStock] };
          });
        })
        .finally(() => {
          products.loading[`${brand_id}-${category_id}`] = false; // Set loading to false once the request is completed
        });
    } else {
      products.loading[`${brand_id}-${category_id}`] = false; // Set loading to false if data already exists
    }
  };

  const getBrandsWithCategories = () => {
    brands.loading = true;
    return axios.authApi
      .get("distributor/brands")
      .then((res) => {
        const raw = res.data.data;
        // if data is empty then loggedOut
        if (!raw) {
          loggedOut();
          return;
        }
        brands.data = raw
          .map((b) => ({
            ...b,
            categoryFilters: [],
            categoriesSearchQuery: "",
            categories: [...(b.categories || [])].sort((a, b) =>
              a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
            ),
          }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
          );
      })
      .finally(() => {
        brands.loading = false;
      });
  };

  const getCategories = (brand) => {
    if (!categories.data[brand.id]) {
      categories.loading[brand.id] = true;
      return axios.authApi
        .get("distributor/categories/" + brand.slug)
        .then((res) => {
          categories.data[brand.id] = res.data.data;
        })
        .finally(() => {
          categories.loading[brand.id] = false;
        });
    }
  };

  return {
    company,
    company_details,
    getProducts,
    products,
    getCategories,
    categories,
    getBrandsWithCategories,
    brands,
  };
}
